import React from "react";
import { scoreBand } from "@/lib/calculations";

export default function ScoreGauge({ score }) {
  const band = scoreBand(score);
  const pct = score == null ? 0 : Math.max(0, Math.min(100, score));
  const R = 60, C = 2 * Math.PI * R;
  const offset = C - (C * pct) / 100;
  return (
    <div className="flex items-center gap-5" data-testid="score-gauge">
      <svg width="150" height="150" viewBox="0 0 150 150">
        <circle cx="75" cy="75" r={R} stroke="#F3F0EA" strokeWidth="14" fill="none" />
        <circle cx="75" cy="75" r={R} stroke={band.color} strokeWidth="14" fill="none"
          strokeDasharray={C} strokeDashoffset={offset} strokeLinecap="round"
          transform="rotate(-90 75 75)" style={{ transition: "stroke-dashoffset 0.6s ease" }} />
        <text x="75" y="72" textAnchor="middle" fontFamily="Playfair Display" fontSize="34" fontWeight="600" fill="#1A1D1F">{Math.round(pct)}</text>
        <text x="75" y="94" textAnchor="middle" fontSize="11" fill="#53585F">out of 100</text>
      </svg>
      <div>
        <div className="text-xs uppercase tracking-wider text-brand-muted">Home Cost Path Purchase Score</div>
        <div className="text-xl font-display mt-1" style={{ color: band.color }}>{band.label}</div>
        <p className="text-xs text-brand-muted mt-2 max-w-xs">Educational planning score. Not used by lenders, VA, or underwriting systems.</p>
      </div>
    </div>
  );
}
